import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getAllLanguagesAsync, getEventLanguagesByEventIdAsync } from './languagesThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const languagesSlice = createSlice({
    name: 'languages',
    initialState,
    reducers: {
        resetLanguagesApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllLanguagesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllLanguagesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.languages = action.payload;
        })
            .addCase(getAllLanguagesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        })
            .addCase(getEventLanguagesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventLanguagesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventLanguages = action.payload;
        })
            .addCase(getEventLanguagesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
    }
});
export const { resetLanguagesApiState } = languagesSlice.actions;
export default languagesSlice.reducer;
